<template>
  <div id="app">
    <header></header>

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" />
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" />

    <FloatBall />
  </div>
</template>

<script>
import { XIZHANG_SEPARATOR } from "@/util/XiZhangUtil"
import { GOODS_CATE_INFO } from "@/api/constant"
import { mall_wx_get_user_info } from "@/api/login"
import { Dialog, Toast } from "vant"
import { $check_bind_card } from "@/page-url-conf.js"

export default {
  name: "App",

  components: {
    FloatBall: () => import("./components/FloatBall"),
    tabBarDrama: () => import("./components/common/tabbar-drama"),
    tabBar: () => import("./components/common/tabbar/index"),
    tabBarBirthday: () => import("./components/common/tabbar-birth/index"),
    tabBarBook: () => import("./components/common/tabbar-books/index"),
    tabBarFestival: () => import("./components/common/tabbar-festival/index"),
    tabBarLife: () => import("./components/common/tabbar-life"),
    tabBarHealth: () => import("./components/common/tabbar-health")
  },

  created() {
    this.$EventBus.$on("routeInfo", (routeInfo) => {
      budo_log.debug("#39 EventBus on routeInfo", routeInfo);
      sessionStorage.setItem("rc.module-info", routeInfo);
      this.moduleInfo = JSON.parse(routeInfo);
    })
  },

  mounted() {
    this.check_bind_card()
  },

  methods: {
    check_bind_card() {
      budo_log.debug("#42 mounted, check_bind_card", location)

      // 是否是需要检查是否绑卡的页面
      if (!$check_bind_card()) {
        budo_log.debug("#55 mounted, no check_bind_card pages", location)
        return // 不是列表中的页面 就不检查
      }

      // 检查 如果用户没卡就引导绑卡
      mall_wx_get_user_info().then(res_user_info => {
        budo_log.debug("#53 App res_user_info=", res_user_info)

        const userData = res_user_info.data || {}

        // 是西藏的 下面的都不检查
        if (userData.openid && userData.openid.indexOf(XIZHANG_SEPARATOR) > -1) {
          budo_log.info("#67 mounted, XIZHANG_SEPARATOR", userData)
          return
        }

        // 是免绑卡快捷登录的 下面的都不检查
        if (userData.openid && userData.openid.indexOf("user-for-card-$$$") > -1) {
          budo_log.info("#73 mounted, user-for-card-$$$", userData)
          return
        }

        // 引导用户绑卡或绑手机
        if (!userData || !userData.wxUserid) {
          budo_log.info("#76 go_bind_card no userData", userData)
          Toast("userData err")
          return
        }

        // 或当前 provider 是 WX 模式 不用绑卡 不用设密码
        if (userData.providerPayMode && "WX" === userData.providerPayMode) {
          budo_log.info("#91 payMode WX, userData=", userData)
          return
        }

        // 其他 支付模式 用户未绑定手机号 并设密码
        if (!userData.mobile || !userData.password) {
          budo_log.info("#93 go_bind_card, userData=", userData)

          this.redirect_bind_mobile()
          return
        }

        // 无卡用户 去绑卡
        if (userData.bindCard < 1) {
          budo_log.info("#94 redirect_bind_card, userData=", userData)
          this.redirect_bind_card()
        }

        budo_log.debug("#98 no redirect_bind_card, userData=", userData)
      })
    },

    // 去绑卡
    redirect_bind_card() {
      Dialog({ message: "未绑定卡券,立即绑定?" }).then(() => {
        location.href = location.origin + "/web/bind-card"
      })
    },

    // 去绑手机
    redirect_bind_mobile() {
      Dialog({ message: "未绑定手机,立即绑定?" }).then(() => {
        location.href = location.origin + "/web/bind-mobile"
      })
    }
  },

  watch: {
    $route(to, from) {
      this.is_goods_detail = to.path === "/goods-detail";
      if (this.moduleInfo) {
        if (this.moduleInfo.name === "birthday") {
          if (
            to.path === "/goods-list" &&
            to.query.cateId === GOODS_CATE_INFO.cake.id.toString()
          ) {
            this.active = 1;
          } else if (
            to.path === "/goods-list" &&
            to.query.cateId === GOODS_CATE_INFO.ticket.id.toString()
          ) {
            this.active = 2;
          } else if (to.path === "/birthday") {
            this.active = 0;
          } else if (to.path === "/user-center-index") {
            this.active = 3;
          }
        } else {
          if (to.path === "/goods-cate-list") {
            this.active = 1;
          } else if (to.path === "/cart") {
            this.active = 2;
          } else if (to.path === "/user-center-index") {
            this.active = 3;
          } else if (to.path === "/goods-list") {
            budo_log.info("#65 watch route active", this.active);
            this.active = 1;
            budo_log.debug("#67 watch route active", this.active);
          } else {
            this.active = 0;
          }
        }
      }
    }
  },

  data() {
    return {
      active: 0,

      exclude: [],

      /**
       * 详情页不显示导航条
       */
      is_goods_detail: false,

      moduleInfo: JSON.parse(sessionStorage.getItem("rc.module-info")),
    };
  }
};
</script>

<style lang="scss">
>#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 14px;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
